import React, { useState, useEffect } from 'react';

const Reviews = () => {
  const [isHovered, setIsHovered] = useState(false);

const reviews = [
    {
        text: "Rozwiń skrzydła w świecie online! Profesjonalna strona internetowa to Twoja najlepsza wizytówka w sieci.",
        author: "Zadowolony Klient",
        stars: "★★★★★"
    },
    {
        text: "Profesjonalne strony internetowe dla Twojego biznesu. Świetna jakość i szybka realizacja!",
        author: "Stały Klient",
        stars: "★★★★★"
    },
    {
        text: "Dostępność 24/7 dla moich klientów to strzał w dziesiątkę. Polecam każdemu!",
        author: "Szczęśliwy Klient",
        stars: "★★★★★"
    },
    {
        text: "Responsywność na wszystkich urządzeniach to ogromny plus. Moja firma wygląda teraz profesjonalnie!",
        author: "Nowy Klient",
        stars: "★★★★★"
    },
    {
        text: "Profesjonalny wizerunek mojej firmy został podkreślony dzięki tej stronie. Jestem zachwycony!",
        author: "Zachwycony Klient",
        stars: "★★★★★"
    },
    {
        text: "Świetna współpraca i szybka realizacja. Strona internetowa spełniła wszystkie moje oczekiwania.",
        author: "Partner Biznesowy",
        stars: "★★★★★"
    },
    {
        text: "Doskonała jakość i przystępne ceny. Moja marka zyskała nowy wymiar w sieci!",
        author: "Zadowolony Użytkownik",
        stars: "★★★★★"
    },
    {
        text: "Nie mam żadnych zastrzeżeń. Strona internetowa działa idealnie i wygląda świetnie!",
        author: "Szczęśliwy Klient",
        stars: "★★★★★"
    },
    {
        text: "Bardzo profesjonalne podejście do klienta. Strona internetowa została wykonana perfekcyjnie!",
        author: "Wdzięczny Klient",
        stars: "★★★★★"
    },
    {
        text: "Polecam każdemu, kto szuka jakości i profesjonalizmu w tworzeniu stron internetowych.",
        author: "Nowy Partner",
        stars: "★★★★★"
    }
];

  // Funkcja do zmiany stanu, aby zatrzymać animację na hover
  useEffect(() => {
    const timer = setInterval(() => {
      if (!isHovered) {
        document.querySelector('.reviews-slider').style.transform = `translateX(-100%)`;
      }
    }, 3000); // Przesuwanie co 3 sekundy

    return () => clearInterval(timer); // Posprzątanie po komponenie
  }, [isHovered]);

  return (
    <div
      className="reviews-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="reviews-slider">
        {reviews.map((review, index) => (
          <div className="review" key={index}>
            <div className="stars">{review.stars}</div>
            <p>{review.text}</p>
            <cite>{review.author}</cite>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
